import { describeResource } from '@siteless/resource';
import CurrentUserResource from './CurrentUser';

export let CurrentUserMustResource = describeResource(
  'CurrentUserMustResource',
  {
    get: async () => {
      let currentUser = await CurrentUserResource.UNSTABLE__getFromStoreOrGet(
        undefined,
      );

      if (currentUser === null || currentUser === undefined)
        throw new Error('CurrentUserMustResource is missing current user');

      return currentUser;
    },
  },
);
